






















































































































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { RegionsModule } from '@/store/Settings/RegionsModule';
import { AuthModule } from '@/store/Auth/AuthModule';
import UpdateRegionRequest from '@/models/Settings/Regions/UpdateRegionRequest';
import TimezoneUtils from '@/lib/timezoneUtils';
import CultureUtils from '@/lib/cultureUtils';

@Component({ name: 'RegionEdit' })
export default class extends SaascadaVueDialog {

  request: UpdateRegionRequest = new UpdateRegionRequest();

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.request = new UpdateRegionRequest();
            this.request.name = this.currentRegion.name;
            this.request.default = this.currentRegion.default;
            this.request.timezone = this.currentRegion.timezone;
            this.request.defaultCulture = this.currentRegion.defaultCulture;
            this.request.availableCurrencies = this.currentRegion.availableCurrencies;
            this.request.defaultCurrency = this.currentRegion.defaultCurrency;
            this.request.workingDays = this.currentRegion.workingDays;
        }
    }

    get listOfTimezones() {
        return TimezoneUtils.getListOfTimezones();
    }

    get listOfCultures() {
        return CultureUtils.getListOfCultures();
    }

    get currentRegion() {
        return RegionsModule.region;
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;
            await RegionsModule.editRegion(this.request);
        }
    }

    get availableCurrencies() {
        return AuthModule.me.institution.config.availableCurrencies;
    }

}
